import { dataTransferWrap } from '../dataTransferService'

import dtConfig from '@/config/data-transfer'
import { ModulesMap } from '@/config/data/modulesMaps'

function patchDoneWorksControlMetric(companyId, doneWorkId, controlMetricId, data) {
	return dataTransferWrap(
		ModulesMap.DONE_WORKS_CONTROL_METRICS,
		dtConfig[ModulesMap.DONE_WORKS_CONTROL_METRICS].patchDoneWorksControlMetric,
		{
			urlParams: {
				companyId,
				doneWorkId,
				controlMetricId,
			},
			...data,
		},
	)
}

function patchDoneWorksControlMetricBulkUpdate(companyId, doneWorkId, data) {
	return dataTransferWrap(
		ModulesMap.DONE_WORKS_CONTROL_METRICS,
		dtConfig[ModulesMap.DONE_WORKS_CONTROL_METRICS].patchDoneWorksControlMetricBulkUpdate,
		{
			urlParams: {
				companyId,
				doneWorkId,
			},
			...data,
		},
	)
}

function getDoneWorksControlMetrics(companyId, doneWorkId) {
	return dataTransferWrap(
		ModulesMap.DONE_WORKS_CONTROL_METRICS,
		dtConfig[ModulesMap.DONE_WORKS_CONTROL_METRICS].getDoneWorksControlMetrics,
		{
			urlParams: {
				companyId: companyId,
				doneWorkId,
			},
		},
	)
}
function getDoneWorksControlMetricPreview(companyId, doneWorkId, controlMetricId) {
	return dataTransferWrap(
		ModulesMap.DONE_WORKS_CONTROL_METRICS,
		dtConfig[ModulesMap.DONE_WORKS_CONTROL_METRICS].getDoneWorksControlMetricPreview,
		{
			urlParams: {
				companyId: companyId,
				doneWorkId,
				controlMetricId,
			},
		},
	)
}
function getDoneWorksControlMetricPopup(companyId, doneWorkId, controlMetricId) {
	return dataTransferWrap(
		ModulesMap.DONE_WORKS_CONTROL_METRICS,
		dtConfig[ModulesMap.DONE_WORKS_CONTROL_METRICS].getDoneWorksControlMetricPopup,
		{
			urlParams: {
				companyId: companyId,
				doneWorkId,
				controlMetricId,
			},
		},
	)
}

function createDoneWorksControlMetric(companyId, doneWorkId, data) {
	return dataTransferWrap(
		ModulesMap.DONE_WORKS_CONTROL_METRICS,dtConfig[ModulesMap.DONE_WORKS_CONTROL_METRICS].createDoneWorksControlMetric, {
		urlParams: {
			companyId,
			doneWorkId,
		},
		...data,
	})
}

function getDoneWorksControlMetric(companyId, doneWorkId, controlMetricId) {
	return dataTransferWrap(
		ModulesMap.DONE_WORKS_CONTROL_METRICS,dtConfig[ModulesMap.DONE_WORKS_CONTROL_METRICS].getDoneWorksControlMetric, {
		urlParams: {
			companyId,
			doneWorkId,
			controlMetricId,
		},
	})
}


function putDoneWorksControlMetric(companyId, doneWorkId, controlMetricId, data) {
	return dataTransferWrap(
		ModulesMap.DONE_WORKS_CONTROL_METRICS,dtConfig[ModulesMap.DONE_WORKS_CONTROL_METRICS].putDoneWorksControlMetric, {
		urlParams: {
			companyId,
			doneWorkId,
			controlMetricId,
		},
		...data,
	})
}

function deleteDoneWorksControlMetric(companyId, doneWorkId, controlMetricId) {
	return dataTransferWrap(
		ModulesMap.DONE_WORKS_CONTROL_METRICS,dtConfig[ModulesMap.DONE_WORKS_CONTROL_METRICS].deleteDoneWorksControlMetric, {
		urlParams: {
			companyId,
			doneWorkId,
			controlMetricId,
		},
	})
}

export default {
	patchDoneWorksControlMetric,
	patchDoneWorksControlMetricBulkUpdate,
	getDoneWorksControlMetrics,
	getDoneWorksControlMetricPopup,
	getDoneWorksControlMetricPreview,
	getDoneWorksControlMetric,
	putDoneWorksControlMetric,
	createDoneWorksControlMetric,
	deleteDoneWorksControlMetric,
}
